// src/config/fairSettings.js

export const FAIR_SIMULATION_OPTIONS = [
  {
    label: "Fast (5,000)",
    value: 5000,
  },
  {
    label: "Standard (50,000)",
    value: 50000,
  },
  {
    label: "High Precision (100,000)",
    value: 100000,
  },
];

export const FAIR_INVESTMENT_CONFIG = {
  min: 0,
  max: 5000000,
  step: 10000,
};